/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AssetsAnalyticsDataViewListEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const assetsAnalyticsDataViewListEntryPoint: EntryPoint<
	AssetsAnalyticsDataViewListEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsAnalyticsDataViewListEntryPointComponent>(
		/* webpackChunkName: "async-assets-analytics-data-view-list-entrypoint" */ './AssetsAnalyticsDataViewListPage.tsx',
	),
	getPreloadProps: () => ({}),
});
